import { checkForUserGroup } from "../../services/UserGroup.js";
import {APP_CONFIG} from "../constants/global-variables.js";

export async function getCurrentBalance() {
    const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/currentbalance`;

    try {
        const res = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
              "Content-Type": "application/json",
            },
          });
        
          checkIfProfileHasChange(res.data);
        return res.data;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

async function checkIfProfileHasChange(data) {
  if (!data || !data['profile_id']) return;
  let profileId = data['profile_id'];
  let currentProfileId = localStorage.getItem('profiledetails_profile_id');
  if(profileId !== currentProfileId) {
    localStorage.removeItem('profiledetails_expiry');
    const userGroup = await checkForUserGroup();
    if (userGroup) {
        window.location.reload();
    }
  }
}

export async function updatecasinocurrency(currency) {
  const url = `${APP_CONFIG.URL.apiBasePath}ajaxauth/updatecasinocurrency`;

  try {
    const res = await axios.post(
      url,
      {
        currency,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return res.data;
  } catch (err) {
    //console.log('Error getting documents', err);
  }
}